export class RateRequestVM {
    Id:number;
    FromCountryId:number;
    FromPortId:number;
    ToCountryId:number;
    ToPortId:number;
    CargoType:number;
    Consigment:number;
    Condition:number;
    Whenportcanlanport:Date;
    NoOfUnits:number;
    Length:number;
    Width:number;
    Height:number;
    Weight:number;
    Sqm:number;
    Cbm:number;
    UserId:number;
    Status:number;
    Cargodescription:string;    
    ShippingLineId:number;
    IsRequestFrombooking:boolean;
    CreatedBy:string;
    transipment:number;
    FileNames:string[];
    CargoMovementStatus:number;
    PhoneNumber:string;
    Email:string;
    FirstName:string;
    LastName:string;
}